/// <reference path="../../app.ts" />
namespace Cfnc {
    "use strict";

    interface ISportsModalScope extends ng.IScope {
        vm: ISportsModal;
    }

    interface ISportsModal {
        selectedFilters: Array<any>;
        disabled: boolean;
        newSport: any;
        selected: string;
        selectedSports: Array<any>;
        sports: Array<any>;

        cancel: () => void;
        ok: () => void;

        setGenderFilter: (string) => void;

        pushSport: () => void;
        popSport: (index: number) => void;
    }

    class SportsModalCtrl implements ISportsModal {
        static controllerId: string = "sportsModalCtrl";
        static $inject: Array<string> = ["common", "$scope", "$uibModalInstance", "selectedFilters", "collegeSports", "sportList"];
        private log;

        selectedFilters: Array<any>;
        sportsFilters: IAvailableFilters;
        disabled: boolean;
        newSport: any;
        selected: string;
        selectedSports: Array<any>;
        sports: Array<any>;

        setGenderFilter: (string) => void;

        constructor(private common: ICommonFactory, private $scope: ISportsModalScope, private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance, selectedFilters: IAvaliableFiltersGroup[], private collegeSports: IAvailableFilters, private sportList: ISportList) {
            this.log = common.logger.getLogFn(SportsModalCtrl.controllerId);            
            this.selectedSports = [];
            this.selectedFilters = selectedFilters || [];
            this.buildSportsList();

            this.buildSelectedSportsList();

            this.activate();

            this.disabled = false;
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, SportsModalCtrl.controllerId).then(() => {
                this.log("Activated Modal");
            });
        }

        cancel() {
            this.$uibModalInstance.dismiss('cancel');
        }

        ok() {
            this.$uibModalInstance.close(this.selectedFilters);
        }

        pushSport() {
            this.selectedSports.push({
                key: this.getNextSportKey(),
                name: this.newSport.sport.sportName,
                code: this.newSport.sport.sportCode,
                gender: this.newSport.gender == "0" ? null : this.newSport.gender,
                division: this.newSport.division == "0" ? null : this.newSport.division,
                scholarship: this.newSport.scholarship
            });

            this.newSport = {};
        }

        popSport(index: number) {
            //for (var i = 0; i < this.selectedSports.length; i++) {
            //    if (this.selectedSports[i].selected) {
            //        this.selectedFilters;
            //        _.pull(this.selectedFilters, _.filter(this.selectedFilters, { key: this.selectedSports[i].key })[0]);
            //        this.selectedFilters;
            //        this.selectedSports.splice(i, 1);
            //    }
            //}
            _.pull(this.selectedFilters, _.filter(this.selectedFilters, { key: this.selectedSports[index].key })[0]);
            this.selectedSports.splice(index, 1);

        }

        buildSelectedSportsList() {
            var sportsFilterGroups = _.filter(this.selectedFilters, (value) => {
                return value.key.match(new RegExp('^Sports'));
            });
            if (_.isArray(sportsFilterGroups)) {
                angular.forEach(sportsFilterGroups, (value, key) => {
                    var sport = {
                        key: value.key,
                        code: _.map(_.filter(value.filters, { key: "Sport" }), "value")[0],
                        name: _.find(this.sports, { sportCode: _.map(_.filter(value.filters, { key: "Sport" }), "value")[0] }).sportName,
                        gender: _.map(_.filter(value.filters, { key: "SportsGender" }), "value")[0],
                        division: _.map(_.filter(value.filters, { key: "SportsDivision" }), "value")[0],
                        scholarship: _.map(_.filter(value.filters, { key: "ScholarshipsAvailable" }), "value")[0]
                    };
                    this.selectedSports.push(sport);
                });
            }

        }

        getNextSportKey(): string {
            var sportNumber = 1;
            if (this.selectedSports.length > 0) {
                sportNumber = Number(_.last(this.selectedSports).key.replace("Sports", "")) + 1;
            }
            
            return "Sports" + sportNumber;
        }

        buildSportsList() {
            this.sports = this.sportList.getSports();
        }
    }

    angular.module("app").controller(SportsModalCtrl.controllerId, SportsModalCtrl);
}